'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var errors = require('./errors.js');

var shard$1 = require('./shard.js');

var base = require('./base.js');

var memory = require('./memory.js');

var keytransform = require('./keytransform.js');

var sharding = require('./sharding.js');

var mount = require('./mount.js');

var tiered = require('./tiered.js');

var namespace = require('./namespace.js');

var Errors = _objectSpread({}, errors);

var shard = _objectSpread({}, shard$1);

exports.BaseDatastore = base.BaseDatastore;
exports.MemoryDatastore = memory.MemoryDatastore;
exports.KeyTransformDatastore = keytransform.KeyTransformDatastore;
exports.ShardingDatastore = sharding.ShardingDatastore;
exports.MountDatastore = mount.MountDatastore;
exports.TieredDatastore = tiered.TieredDatastore;
exports.NamespaceDatastore = namespace.NamespaceDatastore;
exports.Errors = Errors;
exports.shard = shard;